import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { EditorComponent } from '../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
@Component({
  selector: 'app-dms-main-report',
  templateUrl: './dms-main-report.component.html',
  styleUrls: ['./dms-main-report.component.scss']
})
export class DmsMainReportComponent implements OnInit {
  isProcessing: boolean = false;
  showCharts: boolean = false;
  showReportFlagValue: any;
  PageName: any;
  searchValue: any;
  error = '';
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  dropDownForModules: any;
  popupTitle: any;
  groupdataList: any = [];
  dropDownForDateRange: any = [];
  dropDownForInterval: any = [];
  stageValueDropdown: any = [];
  dateRangeValueDropdown: any = [];
  statusValueDropdown: any = [];
  intervalValueDropdown: any = [];
  selectedDateRangeValue: any = null;
  selectedIntervalValue: any = null;
  fromDate: any;
  toDate: any;
  showSpecificInterval: boolean = false;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";
  dateCustomClasses: DatepickerDateCustomClasses[];
  chartOptionsForDMSCount: any;
  chartOptionsForStatus: any;
  chartOptionsForDocType: any;
  pdfSearchText: string = '';
  chartOptionsForDMSCountZoom: any;
  chartOptionsForStatusZoom: any;
  chartOptionsForDocTypeZoom: any;
  showingRowsText = "Showing rows";
  chartWith: string = '100%';
  clickedChartVal: any;
  statusList: any = [];
  dmsCountList: any = [];
  overAllCountList: any = [];
  typeNameList: any = [];
  whereValsForExcel: any;
  tableReportDataList: any = [];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  selectedColumns: any;
  columnList: any;
  htmlContent: any;
  constructor(public dialog: MatDialog, public message: messageService, public appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute,
    public paginationService: PaginationService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    appService.isProcessingRep = false;
  }
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  reportPopupConfig = {
    width: '80%',
    height: '600px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  specificIntervalVal: boolean = false;
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  dateFormat: any = this.message.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    maxDate: new Date()
  }


  resetFunction() {
    this.specificIntervalVal = false;
    this.fromDate = null;
    this.toDate = null;
    this.tableReportDataList = null;
    this.showCharts = false;
  }

  genReport() {
    this.showCharts = false;
    if (this.fromDate && this.toDate && (this.toDate <= this.fromDate)) {
      alert('To Date cannot be before From Date');
    } else {
      let data = {

        groupId: null,
        module: "DOCS",
        dateRangeAt: this.selectedDateRangeValue,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue,
        stageName: null,
        status: null
      }
      this.isProcessing = true;
      const promises = [
        firstValueFrom(this.appService.getDMSCountReportVal(data)),
        firstValueFrom(this.appService.getDocumentCountRepDms(data)),
        firstValueFrom(this.appService.getDocumentTypeNameCountRepDms(data)),
      ];
      Promise.all(promises)
        .then(([dmsCountList, statusCountList, documentTypeList, departmentList, taskTypeList, activityReportList, inprogressVSTotalList, extensionList, ecList, actionList]) => {
          this.dmsCountList = dmsCountList;
          this.statusList = statusCountList;
          this.typeNameList = documentTypeList;
          if (this.typeNameList.length > 50) {
            this.chartWith = "3000px";
          } else if (this.typeNameList.length > 30) {
            this.chartWith = "2000px";
          } else {
            this.chartWith = "100%"
          }
          this.createChart();
          this.isProcessing = false;
        },
          error => {
            console.error('Error in forkJoinObservable:', error);
          });
    }
  }
  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
    }, 1000);
  }
  chartDoubleClick(val: any) {
    this.createChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);
    if (val == 1) {
      this.tableDataListForAll("DMSCount", "", "");
      this.clickedType = "DMSCount";
      this.clickedVal = "DMSCount";
      this.clickedStageStatusVal = "";
    } else if (val == 2) {
      this.tableDataListForAll("DMSStatus", "", "");
      this.clickedType = "DMSStatus";
      this.clickedVal = "DMSStatus";
      this.clickedStageStatusVal = "";
    } else if (val == 3) {
      this.tableDataListForAll("DocType", "", "");
      this.clickedType = "DocType";
      this.clickedVal = "DocType";
      this.clickedStageStatusVal = "";
    }
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
  }
  createChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForDMSCountZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Document Count (${this.getTotalCountDmsCountChart()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        toolTip: {
          shared: true
        },
        data: [{
          type: "line",
          name: "Document Count",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForActivityReport(),
          click: this.handleActivityReportChartClick.bind(this)
        }]

      }
    }
    if (val == 2) {
      this.chartOptionsForStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          fontFamily: "Poppins",
          fontColor: "#0F3659"
        },
        title: {
          text: `Status (${this.getTotalCountStatusCountChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForStatusCount(),
          click: this.handleStatusCountChartClick.bind(this) // Reference the click event handler for the entire pie chart
        }]
      }
    }
    if (val == 3) {
      this.chartOptionsForDocTypeZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: "pointer",
        },
        title: {
          text: `Document Type (${this.getTotalCountDocTypeChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        dataPointMaxWidth: 38,
        dataPointMinWidth: 38,
        scrollablePlotArea: {
          scrollEnabled: this.typeNameList.length > 10,  // Enable scrolling if data points are more than 10
          unit: "pixel",
          maxWidth: 1000,  // Set a larger width for the chart to force horizontal scroll
        },

        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisX: {
          tickLength: 0,
          lineThickness: 0,
          labelAngle: this.typeNameList.length > 25 ? -45 : 0,
          interval: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: function (e: { label: any; value: string; }) {
            let label = null;
            if (e.label != null) {
              if (e.label.length > 15) {
                label = e.label.substring(0, 14) + '...';
              } else {
                label = e.label;
              }
            }
            return label;
          }
        },
        data: [{
          type: "column",
          color: "#00A6A9",
          indexLabel: "{y}",
          indexLabelFontColor: "#0F3659",
          indexLabelFontSize: 12,
          indexLabelFontFamily: "Poppins",
          dataPoints: this.getDataPointsForDocType(),
          click: this.handleDocTypeChartClick.bind(this)
        }]
      };
    }
  }

  createChart() {
    this.chartOptionsForDMSCount = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Document Count (${this.getTotalCountDmsCountChart()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: [{
        type: "line",
        name: "Document Count",
        showInLegend: true,
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForActivityReport(),
        click: this.handleActivityReportChartClick.bind(this)
      }]

    };
    this.chartOptionsForStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        fontFamily: "Poppins",
        fontColor: "#0F3659",
      },
      title: {
        text: `Status (${this.getTotalCountStatusCountChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForStatusCount(),
        click: this.handleStatusCountChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForDocType = {
      animationEnabled: true,
      exportEnabled: true,  // Enables the export button
      exportFileName: "document_type_chart",  // Name of the downloaded file
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Document Type (${this.getTotalCountDocTypeChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: 38,
      dataPointMinWidth: 38,
      scrollablePlotArea: {
        scrollEnabled: this.typeNameList.length > 10,
        unit: "pixel",
        maxWidth: 1000,
      },
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisX: {
        tickLength: 0,
        lineThickness: 0,
        labelAngle: this.typeNameList.length > 25 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: function (e: { label: any; value: string; }) {
          let label = null;
          if (e.label !== null) {
            label = e.label.length > 15 ? e.label.substring(0, 14) + '...' : e.label;
          }
          return label;
        }
      },
      data: [{
        type: "column",
        color: "#00A6A9",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: this.getDataPointsForDocType(),
        click: this.handleDocTypeChartClick.bind(this)
      }]
    };
    this.moveTop();
  }
  getDataPointsForDocType() {
    const dataPoints = this.typeNameList.map((doc: { count: any; documentTypeName: any; }) => ({
      label: `${doc.documentTypeName}`,
      y: doc.count
    }));
    return dataPoints;
  }
  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];
  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }
  }
  getDataPointsForStatusCount() {
    const dataPoints = this.statusList.map((item: { count: any; status: any; }, index: any) => ({
      y: item.count,
      indexLabel: `${item.status}:${item.count}`,
      color: this.colorMethod(item.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForActivityReport() {
    const dataPoints = this.dmsCountList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }
  handleDocTypeChartClick(e: any): void {
    this.titleName = "Document Type"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("DocType", this.typeNameList[e.dataPointIndex].documentTypeName, "");
    this.clickedType = "Doc Type";
    this.clickedVal = this.typeNameList[e.dataPointIndex].documentTypeName;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDocTypeChart() {
    return this.typeNameList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleStatusCountChartClick(e: any): void {
    this.titleName = "DMS Status"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("DMSStatus", this.statusList[e.dataPointIndex].status, "");
    this.clickedType = "DMS Status";
    this.clickedVal = this.statusList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountStatusCountChart() {
    return this.statusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleActivityReportChartClick(e: any): void {
    this.titleName = "Document Count"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("DMSCount", this.dmsCountList[e.dataPointIndex].axisValue, "");
    this.clickedType = "DMS Count";
    this.clickedVal = this.dmsCountList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDmsCountChart() {
    return this.dmsCountList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isRed = false;
    if (['execl-pdf'].includes(fieldId)) {
      isRed = !selectedItems.length;
    } else {
      isRed = !selectedItems;
    }
    field.style.color = field && isRed ? 'red' : '#005c8a';
  }
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  tableDataList(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals;
    if (type == "DMSCount") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "DMSStatus") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'"
    } else if (type == "DocType") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE DOCUMENT_TYPE_NAME='" + valueOfWhere + "'";
    }
    this.whereValsForExcel = whereVals;
    let data = {

      groupId: null,
      module: "DOCS",
      dateRangeAt: this.selectedDateRangeValue,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue,
      stageName: null,
      status: null,
      wherVal: whereVals
    }
    this.whereValsForExcel = whereVals;
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getTableReportDataListForDMS(data)]).subscribe(([stageList]) => {
          this.tableReportDataList = stageList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Axis Value,Intervals,Doc Container,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Associated Document ID,Associated Document From Version,Associated Document To Version,Revision History,CR Details,Document Description,Folder Name,Folder Path,Folder Status,All Parent Folder Status,Is Distributed Folder,Document Type Code,Is Associated Document Type,Belongs To Individual,Assignable At Trainings,Is Amendement Doc Type,Associated Doc To Follow Same Expiry,Belongs User Id,Checkout Flag,Checkedout On,Checkedout By User,Checkedin By User,Checkinout Comments,Is Latest Version,Is Latest Published Version,Is Blinded,Blinded By,Blinded On,Unblinded By,Unblinded On,Unblind Reason,Published On,Published By,Is Extension In Progress,Is Withdrawal In Progress,Is Amendment In Progress,No Of Completed Extension,No Of Completed Amendment,Reason For Status Change,Update Reason,Last Action On,Last Action By,Last Action Comments,Created On,Created By,Updated On,Updated By";
    }
  }
  tableDataListForAll(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals = "";
    this.showReportFlagValue = 1;
    this.whereValsForExcel = whereVals;
    let data = {

      groupId: null,
      module: "DOCS",
      dateRangeAt: this.selectedDateRangeValue,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue,
      stageName: null,
      status: null,
      wherVal: whereVals
    }
    this.whereValsForExcel = whereVals;
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getTableReportDataListForDMS(data)]).subscribe(([stageList]) => {
          this.tableReportDataList = stageList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
          this.setPage1(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Axis Value,Intervals,Doc Container,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Associated Document ID,Associated Document From Version,Associated Document To Version,Revision History,CR Details,Document Description,Folder Name,Folder Path,Folder Status,All Parent Folder Status,Is Distributed Folder,Document Type Code,Is Associated Document Type,Belongs To Individual,Assignable At Trainings,Is Amendement Doc Type,Associated Doc To Follow Same Expiry,Belongs User Id,Checkout Flag,Checkedout On,Checkedout By User,Checkedin By User,Checkinout Comments,Is Latest Version,Is Latest Published Version,Is Blinded,Blinded By,Blinded On,Unblinded By,Unblinded On,Unblind Reason,Published On,Published By,Is Extension In Progress,Is Withdrawal In Progress,Is Amendment In Progress,No Of Completed Extension,No Of Completed Amendment,Reason For Status Change,Update Reason,Last Action On,Last Action By,Last Action Comments,Created On,Created By,Updated On,Updated By";
    }
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  //Excell & PDF
  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    this.dateRangeValueDropdown = this.dropDownForDateRange.map((item: { codelistCode: any; codelistName: any; }) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    this.intervalValueDropdown = this.dropDownForInterval.map((item: { codelistCode: any; codelistName: any; }) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  isSaveReport: boolean = false;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      if (this.showReportFlagValue == 1) {
        tname = "DMS_INTERVALS_REP_VW";
        colList = "AXIS_VALUE,INTERVALS,DOC_CONTAINER,DOCUMENT_TYPE_NAME,DOCUMENT_NO,DOCUMENT_NAME,VERSION,STATUS,EFFECTIVE_DATE,EXPIRATION_DATE,ASSOCIATED_DOCUMENT_NO,ASSOCIATED_DOCUMENT_FROM_VERSION,ASSOCIATED_DOCUMENT_TO_VERSION,REVISION_HISTORY,CR_DETAILS,DOCUMENT_DESCRIPTION,FOLDER_NAME,FOLDER_PATH,FOLDER_STATUS,ALL_PARENT_FOLDER_STATUS,IS_DISTRIBUTED_FOLDER,DOCUMENT_TYPE_CODE,IS_ASSOCIATED_DOCUMENT_TYPE,BELONGS_TO_INDIVIDUAL,ASSIGNABLE_AT_TRAININGS,IS_AMENDEMENT_DOC_TYPE,ASSOCIATED_DOC_TO_FOLLOW_SAME_EXPIRY,BELONGS_USER_NAME,CHECKOUT_FLAG,CHECKEDOUT_ON,CHECKEDOUT_BY_USER,CHECKEDIN_BY_USER,CHECKINOUT_COMMENTS,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,IS_BLINDED,BLINDED_BY_NAME,BLINDED_ON,UNBLINDED_BY_NAME,UNBLINDED_ON,UNBLIND_REASON,PUBLISHED_ON,PUBLISHED_BY_NAME,IS_EXTENSION_IN_PROGRESS,IS_WITHDRAWAL_IN_PROGRESS,IS_AMENDMENT_IN_PROGRESS,NO_OF_COMPLETED_EXTENSION,NO_OF_COMPLETED_AMENDMENT,REASON_FOR_STATUS_CHANGE,UPDATE_REASON,LAST_ACTION_ON,LAST_ACTION_BY_USER,LAST_ACTION_COMMENTS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
        fieldList = "Axis Value,Intervals,Doc Container,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Associated Document ID,Associated Document From Version,Associated Document To Version,Revision History,CR Details,Document Description,Folder Name,Folder Path,Folder Status,All Parent Folder Status,Is Distributed Folder,Document Type Code,Is Associated Document Type,Belongs To Individual,Assignable At Trainings,Is Amendement Doc Type,Associated Doc To Follow Same Expiry,Belongs User ,Checkout Flag,Checkedout On,Checkedout By User,Checkedin By User,Checkinout Comments,Is Latest Version,Is Latest Published Version,Is Blinded,Blinded By,Blinded On,Unblinded By,Unblinded On,Unblind Reason,Published On,Published By,Is Extension In Progress,Is Withdrawal In Progress,Is Amendment In Progress,No Of Completed Extension,No Of Completed Amendment,Reason For Status Change,Update Reason,Last Action On,Last Action By,Last Action Comments,Created On,Created By,Updated On,Updated By";
        this.whereValsForExcel = this.whereValsForExcel == "" ? "" : this.whereValsForExcel + " AND";
        this.whereValsForExcel = this.whereValsForExcel + " ORG_ID=" + this.message.getOrgId();
      }
      const data = {

        groupId: null
      }

      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: "",
        codelistGroup: null,
        manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: "qms",
        footer: this.selectedReportFooter,
        logoId: this.selectedReportLogoValue ?? 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? `${this.clickedType}_${this.clickedVal}`,
        currentStatus: "NA",
        groupName: "",
      }
      let data2 = {

        groupId: null,
        module: "DOCS",
        dateRangeAt: this.selectedDateRangeValue,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue,
        stageName: null,
        status: null,
        wherVal: this.whereValsForExcel + " ORDER BY DOCUMENT_NO"
      }
      this.reportObj = { ...data1, ...data, ...data2 };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');
      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: [],
          "informationTab": {
            "Report Name": `${this.clickedType}_${this.clickedVal}` + "  " + "Report",
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName);
      } else {
        const pdfData = {
          ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}`, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName);
      }
    }
  }
  openReportPopup(item: any) {
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;

    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  buttonClinkFun(value: any) {
    if (value == "Default") {
      this.message.dmsReportButtonVal = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.message.breadcrumbData.fourthLevel = "";
      this.router.navigate(['/dashboard/DmsMainReportComponent']);
    } else {
      this.message.dmsReportButtonVal = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.message.breadcrumbData.fourthLevel = "";
      this.router.navigate(['/dashboard/DMSReportsComponent']);
    }
  }
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const item of this.organizationReportImageDetails) {

              if (item.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown.push({
                  valueExp: item.reportImageId,
                  displayExp: item.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const item of this.organizationReportImageDetails) {
          if (item.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown.push({
              valueExp: item.reportImageId,
              displayExp: item.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const item of this.reportLogoDropdown) {
          if (item.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = item.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("DOCS")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  ngOnInit() {
    this.message.dmsReportButtonVal = 'Default';
    forkJoin([
      this.appService.getCodeListsByGroup('DMS_REPORT_DATE_RANGE'),
      this.appService.getCodeListsByGroup('REPORT_INTERVAL')
    ]).subscribe(([typdropDownForDateRangeData, typdropDownForIntervalData]) => {
      this.dropDownForDateRange = typdropDownForDateRangeData;
      this.selectBoxForDateRange();
      this.dropDownForInterval = typdropDownForIntervalData;
      this.selectBoxForInterval();
      this.selectedDateRangeValue = 'CREATED';
      this.selectedIntervalValue = 'MONTH';
      this.isProcessing = false;
    })
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("DOCS", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
  }
}

